module.exports = __webpack_public_path__ + "img/for_who_3.3381101.jpg";